export const dropdownThemeConfig = {
    borderWidth: '1.5px',
    typography: {
        primary: {
            fontSize: '13px',
            fontWeight: 600,
            letterSpacing: '0.6px',
        },
        invalidMessage: {
            fontSize: '11px',
            letterSpacing: '1px',
        },
    },
};
//# sourceMappingURL=dropdown.js.map